import useInterval from "@lib/hooks/useIntervalHook";
import { IDLE_TIMEOUT, WARNING_THRESHOLD } from "@lib/components/AiChat/sessionStateManagerService";
import { Stack, Tooltip, Typography, useTheme } from "@mui/material";
import Chip from "@mui/material/Chip";
import { useState } from "react";
import { useShallow } from "zustand/react/shallow";
import LoadingDots from "../../Library/LoadingDots";
import { useAiChatServices, useAiChatSessionStore } from "..";
import { Circle } from "@mui/icons-material";
import { ConnectionState as TypeConnectionState } from "@lib/models/connectionState";

type Color = 'success' | 'error' | 'info' | 'secondary'

interface StatusToColorMap {
  [key: string]: Color;
}

const colorMap: StatusToColorMap = {
  "Connecting": 'info',
  "Connected": 'success',
  "Disconnected": 'error',
  "Unknown": 'secondary',
  "Paused": 'secondary',
  "Idle": 'info'
}

const ConnectionState: React.FC = () => {
  const { connectionStatus, sessionActive, lastActivity, loadingError } = useAiChatSessionStore(
    useShallow((state) => ({ connectionStatus: state.connectionStatus, loadingStatus: state.loading, loadingError: state.loadingError, sessionActive: state.sessionActive, lastActivity: state.lastActivity }))
  )
  const [idleTime, setIdleTime] = useState(0);

  const theme = useTheme();

  const getSmallStatus = (state: TypeConnectionState) => {
    switch (state) {
      case TypeConnectionState.Connected:
        return "OK";
      case TypeConnectionState.Connecting:
        return "Connecting";
      case TypeConnectionState.Disconnected:
        return "Disconnected";
      case TypeConnectionState.Idle:
        return "Idle";
      default:
        return "";
    }
  }

  const getState = (): { color: Color, status: string } => {
    if (!sessionActive && connectionStatus !== 'Idle')
      return { color: "secondary", status: "Session Inactive" }

    return { color: colorMap[connectionStatus.toString()], status: getSmallStatus(connectionStatus) }
  }

  useInterval(() => {
    setIdleTime(new Date().getTime() - lastActivity);
  }, 1500);

  const state = getState();

  const showIdle = (idleTime / IDLE_TIMEOUT) > WARNING_THRESHOLD;// && connectionStatus == ConnectionState.Connected;
  const decisionWindow = IDLE_TIMEOUT / WARNING_THRESHOLD / 1000;
  const secondsLeft = Math.ceil((IDLE_TIMEOUT - idleTime) / 1000);

  return <Stack direction="row" gap={1} sx={{ position: 'relative', alignItems: 'center', display: 'flex', flexShrink: 0 }}>
    {connectionStatus != TypeConnectionState.Connected && (
      <>
        <div style={{ backgroundColor: 'rgba(0,0,0,0.4)', position: 'absolute', width: '100%', height: '100%' }}></div>
        <Chip label={sessionActive ? state.status : "Session Inactive"} sx={{ minWidth: '100px' }} color={state.color} size="small"
          variant="outlined" />
      </>)
    }


    {showIdle && secondsLeft > 0 && <>
      <Typography color="textPrimary">Idle:</Typography>
      <Chip label={secondsLeft} color={secondsLeft < decisionWindow / 2 ? 'warning' : 'info'} size="small"
        variant="outlined" />
    </>}

    {/* {loadingStatus && <LoadingDots />} */}
    {!!loadingError && connectionStatus != TypeConnectionState.Connected && (
      <Tooltip title={loadingError} sx={{ cursor: 'pointer' }}>
        <Typography variant="caption" noWrap style={{ color: theme.palette.error.light, fontStyle: 'italic', overflow: 'clip', minWidth: 0, maxWidth: '250px' }}>{loadingError}</Typography>
      </Tooltip>
    )}
  </Stack >
}

export default ConnectionState;